import { render, staticRenderFns } from "./AssignedLetters.vue?vue&type=template&id=49d01220"
import script from "./AssignedLetters.vue?vue&type=script&lang=js"
export * from "./AssignedLetters.vue?vue&type=script&lang=js"
import style0 from "./AssignedLetters.vue?vue&type=style&index=0&id=49d01220&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports